import EmptyComponent from './components/emptyComponent.vue';
import { RouteConfig } from 'vue-router';
import  CheckOutPage  from './msw-checkout.vue';

const checkoutRoute: RouteConfig = {
  path: 'checkout',
  component: EmptyComponent,
  children:[{
    path: 'billing',
    component:CheckOutPage,
  }, {
    path: 'payment',
    component:CheckOutPage,
  }, {
    path: 'confirmation',
    component: CheckOutPage,
  }, {
    path: 'order_details',
    component: CheckOutPage,
  }],
};

export default checkoutRoute;
